
// // import {
// //   DesktopOutlined,
// //   SettingOutlined,
// //   CustomerServiceOutlined,
// //   FileTextOutlined,
// //   FileSyncOutlined,
// //   DashboardOutlined,
// //   TeamOutlined,
// //   UserOutlined,
// //   CreditCardOutlined,
// //   BankOutlined,
// // } from "@ant-design/icons";

// // export const IconMenu = ({ name }) => {
// //   const components = {
// //     DesktopOutlined: DesktopOutlined,
// //     SettingOutlined: SettingOutlined,
// //     CustomerServiceOutlined: CustomerServiceOutlined,
// //     FileTextOutlined: FileTextOutlined,
// //     FileSyncOutlined: FileSyncOutlined,
// //     DashboardOutlined: DashboardOutlined,
// //     TeamOutlined: TeamOutlined,
// //     UserOutlined: UserOutlined,
// //     CreditCardOutlined: CreditCardOutlined,
// //     BankOutlined: BankOutlined,
// //     Default: DesktopOutlined,
// //   };

// //   const IconTag = components[name || "Default"] || SettingOutlined;
// //   return <IconTag />;
// // };

// export const routesConfig = [
//   // {
//   //   path: '/',
//   //   component: 'Dashboard',
//   // },
//   {
//     path: '/',
//     component: 'AttendanceReport',
//   },
//   {
//     path: '/register-user',
//     component: 'SignUpEmployee',
//     private: true,
//   },
//   {
//     path: '/lead',
//     component: 'Customer',
//     private: true,
//   },
//   {
//     path: '/invoice',
//     component: 'Invoice',
//     // private: true,
//   },
//   {
//     path: '/projecttracking',
//     component: 'Quote',
//   },
//   {
//     path: '/maintenance',
//     component: 'MaintenancePlanNew',

//   },

//   {
//     path: '/payment/invoice',
//     component: 'PaymentInvoice',
//     private: true,
//   },
//   {
//     path: '/employees',
//     component: 'Employees/Employees',
//     private: true
//   },
//   {
//     path: '/reset-password/:token',
//     component: 'ResetPasswordScreen',
//     private: false // make it public so employee can access without login
//   },
//   {
//     path: '/employees/edit/:employeeId',
//     component: 'Employees/EmployeeEdit',
//     private: true
//   },
//   {
//     path: '/employees/show/:employeeId',
//     component: 'Employees/EmployeeShow',
//     private: true
//   },
//   {
//     path: '/recruitment',
//     component: 'Recruitment/Recruitment',
//     private: true,
//   },
//   {
//     path: '/candidate/:candidateId',
//     component: 'Recruitment/RecruitmentEdit',
//     private: true,
//   },
//   {
//     path: '/hire-req/create',
//     component: 'HireReq/HireReqForm',
//     private: true,
//   },

//   {
//     path: '/hire-req',
//     component: 'HireReq/HireReq',
//     private: true,
//   },
//   {
//     path: '/ai-text-detector',
//     component: 'AITextDetector',
//   },
//   {
//     path: '/image-collage',
//     component: 'ImageCollage',
//   },
//   {
//     path: '/salary-management',
//     component: 'SalaryTable',
//     private: true,
//   },
//   {
//     path: '/payrolls',
//     component: 'SalaryTable',

//   },
//   // {
//   //   path: '/admin',
//   //   component: 'Admin',
//   //   private: true,
//   // },
//   {
//     path: '/settings',
//     component: 'Settings/Settings',
//   },
//   {
//     path: '/payment/mode',
//     component: 'PaymentMode',
//     private: true,
//   },
//   {
//     path: '/role',
//     component: 'Role',
//   },

//   {
//     path: '/proposal',
//     component: 'Proposal',
//   },

//   {
//     path: '/proposals/all-proposals',
//     component: 'AllProposals',
//   },
//   {
//     path: '/edit-proposal/:id', // Add this for editing proposals
//     component: 'EditProposal',
//   },
//   {
//     path: '/daily-activity-log',
//     component: 'AttendanceReportsHR/AttendanceLog',
//     private: true,
//   },
//   {
//     path: '/attendance-report',
//     component: 'AttendanceReportsHR/TimeInRecords',
//     private: true,
//   },
//   // {
//   //   path: '/time-in-records',
//   //   component: 'AttendanceReportsHR/TimeInRecords',
//   //   private: true,
//   // },
//   {
//     path: '/attendance-report',
//     component: 'AttendanceReportsHR/MonthlySummary',
//     private: true,
//   },
//   {
//     path: '/extra-hours-logs',
//     component: 'AttendanceReportsHR/ExtraHoursLogs',
//   },
//   {
//     path: '/complaint',
//     component: 'Complaint',
//   },
//   {
//     path: '/attendance-dashboard',
//     component: 'AttendanceCard',
//   },

//   {
//     path: '/leaves',
//     component: 'LeavesForm',
//   },
//   {
//     path: '/LeaveRequestList',
//     component: 'LeaveRequestList',
//   },
//   {
//     path: '/suggestions&complaints',
//     component: 'ComplainOrSuggestion',
//   },
//   {
//     path: '/complaint-list',
//     component: 'ComplaintList',
//   },
//   {
//     path: '/suggestion-list',
//     component: 'SuggestionList',
//   },
//   {
//     path: '/activity-scorecard',
//     component: 'ActivityScoreCard',
//   },
//   {
//     path: '/voice-over',
//     component: 'VoiceOverElevenLabs',
//   },
//   {
//     path: '/colorpicker',
//     component: 'ColorPicker',
//   },
//   {
//     path: '/meta-length-checker',
//     component: 'MetaLengthChecker',
//   },
//   {
//     path: '/page-speed-insights',
//     component: 'PageSpeedInsights',
//   },
//   {
//     path: '/google-trends',
//     component: 'GoogleTrends',
//   },
//   {
//     path: '/google-keywords-planner',
//     component: 'GoogleKeyWordsPlanner',
//   },
//   {
//     path: '/create-announcement',
//     component: 'Annoucements',
//     private: true
//   },
//   {
//     path: '/announcement-feeds',
//     component: 'AnnoucementsFeeds',
//   },
//   {
//     path: '/focusPing',
//     component: 'GenerateEnergySound',
//   },
//   {
//     path: '/birthday-buzz',
//     component: 'EmployeeBirthadyNot',
//     private: true
//   },
//   {
//     path: '/extraHours',
//     component: 'ExtraHours',
//   },
//   {
//     path: '/client-task-log',
//     component: 'ClientTaskLog',
//     private:true
//   },
//   {
//     path: '/users',
//     component: 'UsersList',
//     private:true
//   },
//   {
//     // path: '/overtime-report',
//     path: '/overtime-extrahours',

//     component: 'AttendanceReportsHR/OvertimeTable',
//     private:true
//   },
//   {
//     path: '/technician-logs',
//   component: 'TechnicianLogs',
//     private:true
//   },
// ];



export const routesConfig = [
  {
    path: '/',
    component: 'Dashboard',
    private: false,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/register-user',
    component: 'SignUpEmployee',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['create']
  },
  {
    path: '/lead',
    component: 'Customer',
    private: true,
    roles: ['super_admin', 'Admin', 'Manager', 'BD'],
    permissions: ['read', 'update']
  },
  {
    path: '/invoice',
    component: 'Invoice',
    roles: ['super_admin', 'Admin', 'finance_admin', 'Client'],
    permissions: ['read', 'create', 'update']
  },
  {
    path: '/projecttracking',
    component: 'Quote',
    roles: ['super_admin', 'Admin', 'Manager', 'Client'],
    permissions: ['read']
  },
  {
    path: '/maintenance',
    component: 'MaintenancePlanNew',
    private: true,
    roles: ['finance_admin', 'Manager'],
    permissions: ['read', 'update']
  },
  {
    path: '/payment/invoice',
    component: 'PaymentInvoice',
    private: true,
    roles: ['super_admin', 'Admin', 'finance_admin'],
    permissions: ['read', 'create']
  },
  {
    path: '/employees',
    component: 'Employees/Employees',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read', 'update', 'create', 'delete']
  },
  {
    path: '/reset-password/:token',
    component: 'ResetPasswordScreen',
    private: false,
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/employees/edit/:employeeId',
    component: 'Employees/EmployeeEdit',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['update']
  },
  {
    path: '/employees/show/:employeeId',
    component: 'Employees/EmployeeShow',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/employees/offboarding/:caseId',
    component: 'Employees/OffboardingCaseDetail',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['read', 'update']
  },
  {
    path: '/recruitment',
    component: 'Recruitment/Recruitment',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['read', 'create']
  },
  {
    path: '/candidate/:candidateId',
    component: 'Recruitment/RecruitmentEdit',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['read', 'update']
  },
  {
    path: '/hire-req/create',
    component: 'HireReq/HireReqForm',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['create']
  },
  {
    path: '/hire-req',
    component: 'HireReq/HireReq',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['read']
  },
  {
    path: '/ai-text-detector',
    component: 'AITextDetector',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/image-collage',
    component: 'ImageCollage',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/salary-management',
    component: 'Salarymanagement',
    private: true,
    roles: ['super_admin', 'Admin', 'finance_admin', 'hr_admin', 'Employee'],
    permissions: ['read', 'update', 'create']
  },
  {
    path: '/payrolls',
    component: 'SalaryTable',
    roles: ['super_admin', 'Admin', 'finance_admin', 'hr_admin'],
    permissions: ['read']
  },
  {
    path: '/settings',
    component: 'Settings/Settings',
    roles: ['super_admin', 'Admin'],
    permissions: ['read', 'update', 'manage-config']
  },
  {
    path: '/payment/mode',
    component: 'PaymentMode',
    private: true,
    roles: ['super_admin', 'Admin', 'finance_admin'],
    permissions: ['read', 'create', 'update']
  },
  {
    path: '/role',
    component: 'Role',
    roles: ['super_admin', 'Admin'],
    permissions: ['read', 'update', 'manage-users']
  },
  {
    path: '/proposal',
    component: 'Proposal',
    roles: ['super_admin', 'Admin', 'Manager', 'Client'],
    permissions: ['read', 'create']
  },
  {
    path: '/proposals/all-proposals',
    component: 'AllProposals',
    roles: ['super_admin', 'Admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/edit-proposal/:id',
    component: 'EditProposal',
    roles: ['super_admin', 'Admin', 'Manager'],
    permissions: ['update']
  },
  {
    path: '/daily-activity-log',
    component: 'AttendanceReportsHR/AttendanceLog',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/attendance-report',
    component: 'AttendanceReportsHR/TimeInRecords',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/attendance-report',
    component: 'AttendanceReportsHR/MonthlySummary',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/extra-hours-logs',
    component: 'AttendanceReportsHR/ExtraHoursLogs',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read'],
    private: true,
  },
  {
    path: '/complaint',
    component: 'Complaint',
    roles: ['all'],
    permissions: ['read', 'create']
  },
  {
    path: '/feedback',
    component: 'FeedbackPage',
    roles: ['all'],
    permissions: ['read', 'create']
  },
  {
    path: '/complain-or-suggestion',
    component: 'ComplainOrSuggestion',
    roles: ['all'],
    permissions: ['create']
  },
  {
    path: '/complaint-list',
    component: 'ComplaintList',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/suggestion-list',
    component: 'SuggestionList',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/attendance-dashboard',
    component: 'AttendanceCard',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/leaves',
    component: 'LeavesForm',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read', 'create']
  },
  {
    path: '/LeaveRequestList',
    component: 'LeaveRequestList',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/suggestions&complaints',
    component: 'ComplainOrSuggestion',
    roles: ['all'],
    permissions: ['create', 'read']
  },
  {
    path: '/complaint-list',
    component: 'ComplaintList',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/suggestion-list',
    component: 'SuggestionList',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/activity-scorecard',
    component: 'ActivityScoreCard',
    roles: ['super_admin', 'Admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/voice-over',
    component: 'VoiceOverElevenLabs',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/colorpicker',
    component: 'ColorPicker',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/meta-length-checker',
    component: 'MetaLengthChecker',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/page-speed-insights',
    component: 'PageSpeedInsights',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/google-trends',
    component: 'GoogleTrends',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/google-keywords-planner',
    component: 'GoogleKeyWordsPlanner',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/create-announcement',
    component: 'Annoucements',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['create', 'read']
  },
  {
    path: '/announcement-feeds',
    component: 'AnnoucementsFeeds',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/focusPing',
    component: 'GenerateEnergySound',
    roles: ['all'],
    permissions: ['read']
  },
  {
    path: '/birthday-buzz',
    component: 'EmployeeBirthadyNot',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['read', 'create']
  },
  {
    path: '/extraHours',
    component: 'ExtraHours',
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read', 'create']
  },
  {
    path: '/client-task-log',
    component: 'ClientTaskLog',
    private: true,
    roles: ['super_admin', 'Admin', 'Manager', 'Client', 'Employee'],
    permissions: ['read']
  },
  {
    path: '/users',
    component: 'UsersList',
    private: true,
    roles: ['super_admin', 'Admin'],
    permissions: ['manage-users']
  },
  {
    path: '/overtime-extrahours',
    component: 'AttendanceReportsHR/OvertimeTable',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/technician-logs',
    component: 'TechnicianLogs',
    private: true,
    roles: ['super_admin', 'Admin', 'Manager'],
    permissions: ['read']
  },
  {
    path: '/roles-permissions',
    component: 'RolePage',
    private: true,
    roles: ['super_admin'],
    permissions: ['all']
  },
  {
    path: '/my-profile',
    component: 'MyProfile',
    private: true,
    roles: ['all'], // Allow all roles; banner logic will hide for super_admin
    permissions: ['all']
  },
  {
    path: '/email',
    component: 'EmailFeature',
    private: false,
    roles: ['all'],
    permissions: ['all']
  },
  {
    path: '/leavebenefitrequests',
    component: 'LeaveBenefitRequests',
    private: false,
    roles: ['super_admin'],
    permissions: ['all']
  },
  {
    path: '/leavesummary',
    component: 'LeaveSummary',
    private: false,
    roles: ['all'],
    permissions: ['all']
  },
  {
    path: '/reviewappraisals',
    component: 'ReviewAppraisals',
    private: true,
    roles: ['all'],
    permissions: ['all']
  },
  {
    path: '/appraisalhistory',
    component: 'AppraisalHistory',
    private: false,
    roles: ['all'],
    permissions: ['all']
  },
  {
    path: '/events-reminders',
    component: 'EventsReminders/index',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read'],
  },
  {
    path: '/chatbot-admin',
    component: 'ChatbotAdmin',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin'],
    permissions: ['all']
  },
  {
    path: '/organizational-hierarchy',
    component: 'Employees/TeamHierarchy',
    private: true,
    roles: ['super_admin', 'Admin', 'hr_admin', 'Manager', 'Employee'],
    permissions: ['read']
  },
];



